"use strict";

import $ from "jquery";
import debounce from "lodash/debounce";

let form;

const deleteButtonSelector = "#data-hub-delete-saved-search";
const savedSearchesContainerSelector = "#saved-searches-container";
const editSearchObjectSelector = "#edit_search_object";
const searchObjectNameSelector = "#search_object_name";
const savedSearchIdSelector = "#saved_search_data_hub_search_id";
const selectedSavedSearchIdSelector = "#search_object_current_search_id";
const unstashedSearchIdSelector = "#search_object_search_object_id";
const whichButtonClickedSelector = "input[name=which_button_clicked]";
const saveSearchSubmitSelector = ".save-search-submit";
const saveSearchOverrideIdSelector = "#search_object_override_saved_search_id";
const addDownloadButtonSelector = ".add-download";

const disableSavedSearchButton = function () {
  $(saveSearchSubmitSelector).addClass("disabled");
};

const savedSearchSelected = function () {
  $(this).closest("form").submit();
};

const isSearchSaved = function () {
  return form.find(selectedSavedSearchIdSelector).val() != "";
};

const findPopoverElement = function (element) {
  // (BS5): BS5 stores the instance in its OWN registry, not jQuery
  // `.data("bs.popover")` (which is undefined), and there is no `.$tip`. The
  // shown tip is linked to the trigger via `aria-describedby` (set before the
  // `inserted.bs.popover` event fires), so resolve the tip by that id.
  const id = $(element).attr("aria-describedby");
  return id ? $("#" + id) : $();
};

const namePopoverFormSubmitted = function (e) {
  e.preventDefault();
  e.stopPropagation();

  const popover = $(this).closest(".popover");
  const newNameFormGroup = popover.find(".new-name-form-group");
  const newNameFormInput = newNameFormGroup.find("input[type='text']");

  if (newNameFormInput.val() === "") {
    newNameFormGroup.addClass("has-error");
    newNameFormInput.focus();
  } else {
    form.find(searchObjectNameSelector).val(newNameFormInput.val());

    form.submit();
    popover.hide();
  }
};

const loadData = function(url, cb) {
  $.ajax(url, {
    success: cb,
    error: (error) => window.alert(`Error: ${error}`)
  });
};

const ajaxPopoverSubmit = function (e) {
  let isSave;
  if (e) {
    e.preventDefault();
    isSave = $(e.target).hasClass("not-download");
  }
  const inputSelector = isSave ? ".save-search-submit" : ".download-search-submit";
  const $input = $(inputSelector);
  const $popover = findPopoverElement($input[0]);
  const $form = $(editSearchObjectSelector);
  let newNameFormInput, newNameFormGroup;
  const downloadButtonClicked = $(whichButtonClickedSelector).val() == "Download";
  const hackyDownlodModalNoticeShow = function () {
    // Hacky way to bring up downloading modal
    $("#downloadingModal").modal("show");
  };

  if (isSearchSaved()) {
    newNameFormInput = $form.find(searchObjectNameSelector);
    newNameFormInput.val($(savedSearchIdSelector).children(":selected").html());
  } else {
    newNameFormGroup = $popover.find(".new-name-form-group");
    newNameFormInput = newNameFormGroup.find("input[type='text']");
  }

  if (!newNameFormInput.prop("disabled") && newNameFormInput.val() === "") {
    newNameFormGroup.addClass("has-error");
    newNameFormInput.focus();
  } else {
    if (!isSearchSaved()) {
      $form.find(searchObjectNameSelector).val(newNameFormInput.val());
    }

    $.post(`${$form.attr("action")}.html`, $form.serialize(), (data) => {
      if (isSave) {
        const $data = $(data);
        const $newSelect = $data.find(savedSearchesContainerSelector).find("select");
        const $newSavedSearches = $newSelect.children();
        const $select = $(savedSearchesContainerSelector).find("select");

        // Find which search to select
        const $filteredSearches = $newSavedSearches.filter((i, option) => {
          return !$select.children().toArray().map((old_option) => {
            return old_option.outerHTML.replace(/ selected="selected"/, "");
          }).includes(option.outerHTML);
        });
        const currentSearch = $filteredSearches[$filteredSearches.length - 1];

        $select.empty();
        $select.append($newSavedSearches);
        // $select.prepend("<option value>Choose a saved search</option>");
        $select.val($(currentSearch).val());

        // Update Delete button
        const $newDeleteButton = $data.find(deleteButtonSelector);
        $(deleteButtonSelector).removeClass("disabled").prop("href", $newDeleteButton.prop("href"));

        // Makes it possible to immediately download the search, as it turns isSearchSaved to true;
        form.find(selectedSavedSearchIdSelector).val($(currentSearch).val());

        // If the search_object_id param doesn't get set to the new one we'll keep generating new saved searches
        // for whatever reason
        form.find(unstashedSearchIdSelector).val($data.find(unstashedSearchIdSelector).val());
        disableSavedSearchButton();
      } else if (isSearchSaved()) {
        hackyDownlodModalNoticeShow();
      } else if (downloadButtonClicked) {
        hackyDownlodModalNoticeShow();
      }
    });
    $input.popover("hide");
  }
};

const namePopoverElementClicked = function (e) {
  e.preventDefault();
  e.stopPropagation();
  $(".download-search-submit, .save-search-submit").not($(this)).popover("hide");
  form.find(whichButtonClickedSelector).val($(this).text());

  if (isSearchSaved()) {
    ajaxPopoverSubmit();
  } else {
    const el = this;
    loadData($(el).data("content-url"), (data) => {
      // (BS5): BS3 re-read the `data-content` attr on each show; BS5 reads
      // `data-bs-content` once at init only, so push the AJAX-loaded HTML onto the
      // instance via `setContent`. setContent stashes `_newContent`, consumed when
      // the (disposed-on-hide) tip is rebuilt on show — so re-opens pick up fresh
      // content. The instance is created with `sanitize:false, html:true` (at the
      // init call below — BS5 won't honour those via data-attrs) so the form's
      // <input>/<form> survive BS5's sanitizer. The header keeps the trigger's title.
      const popover = window.bootstrap.Popover.getOrCreateInstance(el);
      // BS5 moves the trigger's `title` to `data-bs-original-title` at init, so read
      // the header text from there. setContent REPLACES the content map, so include
      // both the header (else it's dropped) and the AJAX body.
      popover.setContent({
        ".popover-header": $(el).attr("data-bs-original-title") || "",
        ".popover-body": data
      });
      $(el).popover("show");
      $(saveSearchOverrideIdSelector).prop("value", "");
    });
  }
};

const namePopoverInserted = function () {
  const popover = findPopoverElement(this);
  popover.find(".cancel").on("click", () => $(this).popover("hide"));
  popover.find("form").on("submit", namePopoverFormSubmitted);
  // NB: placement is `right` at the init call below (BS5's embedded Popper 2), which
  // restores BS3's own default popover placement. Prod (BS3) also carried a redundant
  // `new Tether(... middle left/middle right)` here that pinned the same right-centered
  // position; dropping the `tether` dep, Popper owns placement (with viewport flip).
};

const namePopoverShown = function () {
  const $popover = findPopoverElement(this);
  $popover.find("input[type=text]").focus();
  let $submitButton = $popover.find(".save");
  $submitButton.on("click", ajaxPopoverSubmit);
  $submitButton.closest("form").find("input").on("keyup", (e) => {
    const $input = $(e.target);
    const html = $submitButton.parent().html();
    if (html && html.match(/data-bs-toggle="\w+"/)) {
      if ($input.val().length) {
        $submitButton.parent().html(html.replace(/data-bs-toggle="\w+"/, "data-bs-toggle='modal'"));
      } else {
        $submitButton.parent().html(html.replace(/data-bs-toggle="\w+"/, "data-bs-toggle='false'"));
        // $submitButton = $popover.find(".add-download");
        // $submitButton.on("click", () => { return false; });``
      }
    }
    $submitButton = $popover.find(addDownloadButtonSelector);
    $submitButton.on("click", ajaxPopoverSubmit);
  }).on("keydown", (e) => {
    if (e.which == 13) {
      e.preventDefault();
      e.stopPropagation();
      // $submitButton.closest("form").find("input").trigger("blur");
      $submitButton.trigger("click");
    }
  });
};

const synchroniseRegionsAndCountries = function () {
  const $countrySelect = $("select.multilevel.country");
  const $allOptions = $countrySelect.children().clone();
  $("select.multilevel.region").on("change", (e) => {
    const selectedRegions = $(e.target).val();
    if (selectedRegions) {
      $countrySelect.empty();
      const relevantOptions = $allOptions.filter((i, child) => {
        return selectedRegions.includes(child.getAttribute("data-region"));
      });
      $countrySelect.append(relevantOptions);
    } else {
      $countrySelect.append($allOptions);
    }
  });
};

const dataHubDependentFiltersInit = function (radioContainerFilter) {
  const containerFilter = radioContainerFilter;
  return function () {
    const hide = function (fc) {
      fc.addClass("hidden");
      fc.find(".checkbox input").prop("checked", false);
    };
    const dependentFilters = $(".filter-group[data-dependent-filter-id='" + containerFilter + "']");
    const radioButtonContainer = $("#" + containerFilter);
    const checkedButton = radioButtonContainer.find("input");
    let checkedValue = checkedButton.prop("value");
    let allBlank;

    if (checkedButton.length < 1) {
      checkedValue = radioButtonContainer.find("option:selected").prop("value");
    }

    allBlank = !checkedValue;

    dependentFilters.each(function () {
      const filterContainer = $(this);
      const show = $.inArray(checkedValue, filterContainer.data().dependentFilterShowValues) !== -1;

      if (allBlank) {
        hide(filterContainer);
        return;
      }

      if (show) {
        filterContainer.removeClass("hidden");
      } else {
        hide(filterContainer);
      }
    });
  };
};

const changeSavedSearchSelection = function (e) {
  e.preventDefault();
  const $select = $(e.target);
  const $form = $select.closest("form");
  if (!$form.find("#saved_search_data_hub_search_id option:selected").prop("value")) {
    window.location = $form.prop("action");
    return;
  }
  $form.submit();
};

const deleteSavedSearch = function (e) {
  e.preventDefault();
  $.ajax({
    method: "DELETE",
    url: $(e.target).closest("a")[0].href + ".json"
  }).done(function () {
    const optionsObj = $(savedSearchIdSelector)[0].options;
    $(optionsObj[optionsObj.selectedIndex]).remove();
    $("input[value='Reset all']").trigger("click");
  });
};

const switchTpCapacity = function (e) {
  const $button = $(e.target);
  const showId = "#" + $button.data("fg-id");

  $button.siblings("button").removeClass("active");
  $button.addClass("active");

  const ids = [];
  $button.parent().children("button").each(function (i, button) {
    ids.push($(button).data("fg-id"));
  });
  ids.forEach(function (id) {
    id = "#" + id;
    if (id != showId) {
      $(id).addClass("hidden");
      let $inputs;
      if (id.match(/tp/)) {
        $inputs = $(id).find("input");
        for (let i = 0; i < $inputs.length; i++) {
          $($inputs[i]).val($($inputs[i]).attr("value")).trigger("change");
        }
      } else {
        $inputs = $(id).find("input");
        Array.from($inputs).forEach(function (input) {
          input.outerHTML = input.outerHTML.replace(/value="\w+"/, "");
        });
        $inputs.val("");
        $(id).find("select.select2").val("").trigger("change");
      }
    }
  });
  $(showId).removeClass("hidden");
};

const makeContentClickFocusOnInput = function () {
  $(".form-group.string").parent().on("click", function (e) {
    $(e.target).find("input").focus();
  });
};

const focusInputOnImgClick = function () {
  let action = "open";
  $(".form-group").siblings("img").on("mouseover", function (e) {
    const $select = $(e.target).siblings(".form-group").find(".select");
    if (!$select.length) return;
    action = $select.siblings(".select2-container--open").length ? "close" : "open";
  });
  $(".form-group").siblings("img").on("click", function (e) {
    const $select = $(e.target).siblings(".form-group").find(".select");
    if ($select.length) {
      $(e.target).siblings(".form-group").find(".select").select2(action);
      action = $select.siblings(".select2-container--open").length ? "close" : "open";
    } else {
      $(e.target).siblings(".form-group").trigger("click");
    }
  });
};

const checkBoxButtonFilterInit = function () {
  $(".check-box-button-filter-container").each(function () {
    const container = $(this);
    const idTarget = container.data().hiddenInputId;
    let hiddenInput;
    const btns = container.find(".btn");

    if (idTarget) {
      hiddenInput = container.closest("form").find("#" + idTarget);
    } else {
      hiddenInput = container.find(".submit-field");
    }

    btns.on("click", function (e) {
      const button = $(this);

      hiddenInput.prop("value", button.prop("value"));
      // button.closest("form").find(".primary-search-button").click();
      btns.removeClass("btn-danger").addClass("btn-primary");
      button.removeClass("btn-primary").addClass("btn-danger");

      e.preventDefault();
      e.stopPropagation();
    });
  });
};

const otherInit = function () {
  // Return search results whilst typing
  const inputSelector = "input[id^=search_object_][id$=_value]";
  const triggerFormChange = function () {
    $(inputSelector).closest("form").trigger("change");
  };
  const debouncedSubmit = debounce(triggerFormChange, 500);
  $(inputSelector).on("keyup", debouncedSubmit);
  $("select.select2").on("change", debouncedSubmit);
  $(inputSelector).on("blur", function (e) {
    // We already submit and refresh the form on keyup. No point in doing it on blur as well.
    // TODO: does this interact badly with mouse based copy paste?
    e.preventDefault();
    e.stopPropagation();
  });

  $(savedSearchIdSelector).on("change", changeSavedSearchSelection);
  $("#saved-searches-container a.btn-danger").on("click", deleteSavedSearch);
  $(".filter-toggle").on("click", switchTpCapacity);
  // comment this out because it breaks the defaulr order for datahubs on mobiles
  // if ($(".filter-toggle")) {
  //   $(".filter-toggle").children().first().trigger("click");
  // }
  makeContentClickFocusOnInput();
  focusInputOnImgClick();

  dataHubDependentFiltersInit("fg-id-ed-country-lock");
  dataHubDependentFiltersInit("search_object_company_category_or_sector_filter_value");
  $("#search_object_company_category_or_sector_filter_value").on("change", dataHubDependentFiltersInit("search_object_company_category_or_sector_filter_value"));

  checkBoxButtonFilterInit();

  $("body").on("change", ".saved-search-form input[type='radio']", function () {
    const $checkedRadio = $(this);
    const $popover = $(this).closest(".popover");
    const $newNameFormGroup = $popover.find(".new-name-form-group");
    const $newNameFormInput = $newNameFormGroup.find("input[type='text']");

    if ($checkedRadio.prop("value")) {
      $newNameFormInput.prop("disabled", true).prop("value", "");
      $(saveSearchOverrideIdSelector).prop("value", $checkedRadio.prop("value"));
    } else {
      $newNameFormInput.prop("disabled", false).prop("value", "");
    }
  });
};

const resetFormToAnonymousSearchAndSubmit = function () {
  let newurl;

  if (history.pushState && window.location.search) {
    newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.pushState({ path: newurl }, "", newurl);
  }
  $(savedSearchIdSelector).val("");
  $(selectedSavedSearchIdSelector).val("");
  $(searchObjectNameSelector).val("");
  $(whichButtonClickedSelector).val("Search");
  $(deleteButtonSelector).addClass("disabled");
  $(saveSearchSubmitSelector).removeClass("disabled");

  form.submit();
};

const maybeShowOverlay = function () {
  // TODO(SI): make the DataHub overlay check more resilient;
  if ($(".raise-overlay-on-search").length > 0) {
    $(".data-hub-searching-overlay").removeClass("hidden");
  }
};

const filterTreatmentPlantsStatesBasedOnCountry = function () {
  const $countryWrapper = $("#fg-id-tp-country");
  const $stateWrapper = $("#fg-id-tp-region");

  let checkedCountries = [];

  const simplify = function (s) {
    return s.toLowerCase().normalize("NFKD").replace(/[^\w]/g, "");
  };

  const matcher = function (params, data) {
    const country = data.text;
    let showCountry = true;

    if (checkedCountries.length > 0) {
      showCountry = checkedCountries.indexOf(country) > -1;
    }

    if (!showCountry) {
      return null;
    }

    const term = $.trim(params.term) || "";

    // If there are no search terms, return all of the data
    if (!term) {
      return data;
    }

    let filteredChildren = [];

    $.each(data.children, function (i, child) {
      // Do not display the item if there is no 'text' property
      if (typeof child.text === "undefined") {
        return null;
      }

      // `params.term` should be the term that is used for searching
      // `child.text` is the text that is displayed for the data object
      if (simplify(child.text).indexOf(simplify(term)) > -1) {
        // You can return modified objects from here
        // This includes matching the `children` how you want in nested data sets
        filteredChildren.push(child);
      }
    });

    if (filteredChildren.length > 0) {
      const modifiedData = $.extend({}, data, true);
      modifiedData.children = filteredChildren;
      return modifiedData;
    }

    return null;
  };

  $stateWrapper.find(".select2").select2({
    matcher: matcher,
  });

  const computeCountryList = function () {
    checkedCountries = [];

    $countryWrapper.find("input").each(function () {
      const $this = $(this);
      const checked = $this.prop("checked");

      if (!checked) { return; }

      const countryBox = $this.closest(".checkbox-tree-container").parent().closest(".checkbox-tree-container").length == 1;

      if (countryBox) {
        checkedCountries.push($this.val());
      } else {
        const $countryInputs = $this.closest(".checkbox-tree-child").find(".checkbox-tree-container input");
        $countryInputs.each(function () {
          checkedCountries.push($(this).val());
        });
      }
    });

    // $stateWrapper.find(".select2").select2("destroy");
    // $stateWrapper.find(".select2").select2();
  };

  $countryWrapper.on("change", computeCountryList);
};

$(document).on("turbolinks:load", function () {
  synchroniseRegionsAndCountries();
  form = $(editSearchObjectSelector);
  if (form.length == 0) {
    return;
  }

  filterTreatmentPlantsStatesBasedOnCountry();

  // We are triggering changes on keyup for text inputs. If we don't block the regular change event, it will trigger
  // on blur and force an unnecessary form submit.
  form.find("input[type=text]").on("change", function (e) {
    e.stopPropagation();
    e.preventDefault();
  });

  $("#saved_search_search_id").on("change", savedSearchSelected);

  form.find(".close-filter-group").on("click", function () {
    $(this).parent().remove();
  });

  // BS5: `sanitize` CANNOT be set via a data-attribute (BS5 strips it from the
  // dataset config for security), so the AJAX-loaded save/download form (carrying
  // <input>/<form> the sanitizer would otherwise strip) needs sanitize:false set
  // HERE in JS at instance-creation. `html:true` also rides the data-attr but is
  // set explicitly alongside for clarity.
  $(".download-search-submit, .save-search-submit").popover({ sanitize: false, html: true, placement: "right" })
    .on("click", namePopoverElementClicked)
    .on("inserted.bs.popover", namePopoverInserted)
    .on("shown.bs.popover", namePopoverShown);

  form.on("change", resetFormToAnonymousSearchAndSubmit);
  form.on("change", maybeShowOverlay);

  form.find(".reset-data-hub-search").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).hasClass("ajaxy")) {
      form.find("select.select2").val("").trigger("change");
      // form[0].reset();
      const formInputs = $(".reset-data-hub-search").closest("form").find("input, select").not("[type='submit'], [type='hidden'], [type='checkbox']");
      const formCheckboxes = $(".reset-data-hub-search").closest("form").find("input[type='checkbox']");
      formInputs.val("");
      Array.from(formInputs).forEach(function (input) {
        input.outerHTML = input.outerHTML.replace(/value="\w+"/, "");
      });
      formCheckboxes.each(function () {
        $(this).attr("checked", false);
        if ($(this).length > 0) {
          $(this)[0].indeterminate = false;
        }
      });
      form.submit();
      window.dispatchEvent(new CustomEvent("resetForm"));
    } else {
      location.search = "";
    }
  }).on("mouseover", function () {
    $("input").blur();
  });

  otherInit();
});
